import { render, staticRenderFns } from "./review-submit.vue?vue&type=template&id=7fcbbeca&scoped=true"
import script from "./review-submit.vue?vue&type=script&lang=js"
export * from "./review-submit.vue?vue&type=script&lang=js"
import style0 from "./review-submit.vue?vue&type=style&index=0&id=7fcbbeca&prod&lang=scss&scoped=true"
import style1 from "./review-submit.vue?vue&type=style&index=1&id=7fcbbeca&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fcbbeca",
  null
  
)

export default component.exports